import { uniq } from 'lodash';
import { useGetAllCustomTagsQuery } from '~/apis/monitoring/filter';
import {
  getListingTabGroup,
  hasCustomTagInAllTagOptions,
  parseCustomTagFilterDropdown,
  parseValueToValueArray,
} from '~/utils';
import { useLogger } from '~/hooks';
import { DropDown } from '../@types';
import { useGetFilterParams, usePathParams } from './index';

export const useCustomTagsFilter = () => {
  const { listingStatus, page } = usePathParams();
  const { params, requestFilterParams, setParams, removeParams } = useGetFilterParams();
  const { custom_tag_id_filter } = params;
  const { amplitudeLogging } = useLogger();
  const selectedCustomTagIds = custom_tag_id_filter ? parseValueToValueArray(custom_tag_id_filter) : [];

  const customTagQuery = useGetAllCustomTagsQuery<DropDown<number>>(
    {
      ...requestFilterParams,
      custom_tag_id_filter: [],
    },
    {
      enabled: !!listingStatus,
      staleTime: 5000,
      select: parseCustomTagFilterDropdown,
    }
  );

  const customTagOptions = customTagQuery.data?.list;
  const handleSelect = (value: number[]) => {
    const _value = uniq(value); // MDSDropdown v2 '1-depth-single' 사용시 value 중복 이슈 해결되면 uniq함수 제거

    if (_value.length > 0) {
      amplitudeLogging('applied filter', {
        Type: 'tags',
        Channel: page,
        Page: getListingTabGroup(listingStatus),
      });
      setParams({ custom_tag_id_filter: value }, { replace: true });
    } else {
      removeParams('custom_tag_id_filter');
    }
  };

  const hasSelectedCustomTagIds =
    selectedCustomTagIds &&
    selectedCustomTagIds.length > 0 &&
    hasCustomTagInAllTagOptions(customTagOptions || [], selectedCustomTagIds);

  return {
    list: customTagOptions || [],
    totalCount: customTagQuery.data?.count || 0,
    selected: hasSelectedCustomTagIds ? selectedCustomTagIds : [],
    select: handleSelect,
    disabled: customTagOptions?.length === 0,
    isFetching: customTagQuery.isFetching,
  };
};
